import { ReactNode, useEffect } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import Link from 'next/link';
import { toast } from 'react-toastify';
import CustomHead from './CustomHead';
import Config from '../config/Config';
import styles from '../styles/SettingsLayout.module.css';
import { useAuth } from '../providers/Auth';
import LoadingSpinner from './LoadingSpinner';

interface LayoutProps {
  children: ReactNode;
  pageName: string;
  showLogin?: boolean;
  hideHeader?: boolean;
  community?: any;
}

const RegisterLayout = ({ children, pageName, showLogin, hideHeader, community }: LayoutProps) => {
  const { isAuthenticated, isLoading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (isAuthenticated) {
      toast.success('Already logged in');
      router.push({
        pathname: '/',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return isAuthenticated || isLoading ? (
    <LoadingSpinner pageName={pageName} />
  ) : (
    <>
      <CustomHead pageName={pageName} />
      <nav className={`${styles.registerNavbar} flex items-center justify-between`}>
        <Link href={Config.APP_URL || Config.WORDPRESS_URL}>
          <a className="flex" data-testid="logo">
            <Image src="/ss_logo.svg" alt="SoleSavy Logo" width={112} height={40} />
          </a>
        </Link>
        {showLogin && (
          <div>
            <span className="text-gray-600">Already a member? </span>
            <span className="text-red-500 underline pl-2">
              <Link href="/login">Log in</Link>
            </span>
          </div>
        )}
      </nav>
      <div className={`flex ${styles.registerContent}`}>
        {/* left column */}
        <section className={`bg-registerLeft bg-left-bottom ${styles.registerSideColumn}`} />

        {/* middle */}
        <section className="flex items-center md:flex-grow px-4 md:px-12 pb-6 pt-8">
          <div className="w-centerMessage mx-auto">
            {!hideHeader && (
              <div className="flex justify-between items-center">
                <h1 className="text-2xlg md:text-xxxl font-tommyBlack text-gray-750 pb-2">
                  {pageName}
                </h1>
                {community?.logo && (
                  <div>
                    <Image
                      src={`/${community.logo}`}
                      title={community.name}
                      width={68}
                      height={68}
                    />
                  </div>
                )}
              </div>
            )}
            {children}
          </div>
        </section>

        {/* right colum */}
        <section className={`bg-registerRight bg-right-top ${styles.registerSideColumn}`} />

        <section className="bg-mobileShoes bg-contain md:bg-cover bg-no-repeat w-full min-h-mobileSneakers max-h-mobileSneakers h-full lg:hidden" />
      </div>
    </>
  );
};

RegisterLayout.defaultProps = {
  showLogin: false,
  hideHeader: false,
  community: null,
};
export default RegisterLayout;
